// !! Used to mock variants, should be removed after the endpoint is ready

import {
  DetailedStockRange,
  ProductDetailsOptionsEntity,
  ProductDetailsVariantEntity,
  ProductMediaEntityType,
  StockRange,
} from "@features/products/domain";

const generateRandomNumber = (): string => {
  return Math.floor(Math.random() * 1000000).toString();
};

interface Color {
  name: string;
  hex: string;
}

export const generateVariants = (
  parentId: string,
): ProductDetailsVariantEntity[] => {
  const colors: Color[] = [
    { name: "Red", hex: "#FF0000" },
    { name: "Black", hex: "#000000" },
    { name: "Blue", hex: "#0000FF" },
  ];

  const sizes = ["S", "M", "L"];

  const variants: ProductDetailsVariantEntity[] = [];

  // Generate all possible combinations
  colors.forEach(color => {
    sizes.forEach(size => {
      // ! This is to mock the fact that the red color is not available for the size S
      if (color.name === "Red" && size === "S") return;

      const variant: ProductDetailsVariantEntity = {
        parentId,
        variantId: generateRandomNumber(),
        // sku: `EG${Math.floor(Math.random() * 10000000000000)}`,
        sku: "SA010403RK0098",
        name: "بنطلون جينز",
        isFavorite: true,
        type: "",
        thumbnail: "https://via.placeholder.com/150",
        financials: {
          price: 180,
          profit: 25,
          finalPrice: 180,
          finalProfit: 25,
          // discount: {
          //   price: 80,
          //   startsAt: new Date(),
          //   expiresAt: new Date(Date.now() + 1000 * 60 * 60 * 24),
          //   type: DiscountType.SALE,
          // },
        },
        lockInfo: {
          isLocked: false,
          quantity: 100,
          quantityUsed: 43,
          isOpenForTesting: true,
          expiresAt: new Date(Date.now() + 1000 * 60 * 60 * 24),
        },
        orderTestingInfo: {
          maxQuantity: 80,
          merchantsLeft: 23,
          totalMerchants: 50,
          succeededTestingLockRate: 0.5,
        },
        isMultiVariant: true,
        isPrimary: false,
        isOnSale: true,
        hasSecondPlacementDiscount: false,
        hasAdditionalQuantityDiscount: true,
        stockAvailability: {
          stockRange: StockRange.ABOVE_1000,
          detailedStockRange: DetailedStockRange.MORE_THAN_1000,
        },
        color: color,
        size: size,
        pricingRange: {
          minPrice: 100,
          maxPrice: 500,
        },
        stats: {
          confirmationRate: 65,
          deliveryRate: 45,
        },
        media: [
          {
            type: ProductMediaEntityType.IMAGE,
            url: "https://media.taager.com/d951ccd2-e119-4801-81f4-a1f7a6f64efa.jpg",
            extension: "jpg",
          },
          {
            type: ProductMediaEntityType.IMAGE,
            url: "https://media.taager.com/b09791bd-dd87-40fc-b73a-d78140732735.jpg",
            extension: "jpg",
          },
          {
            type: ProductMediaEntityType.IMAGE,
            url: "https://media.taager.com/ea6b88b5-3d8a-4bad-9b0f-3ace14d5fb8f.jpg",
            extension: "jpg",
          },
          {
            type: ProductMediaEntityType.VIDEO,
            url: "https://media.taager.com/67f9964e-0ea6-4ee5-b747-f405b705e13c.mp4",
            extension: "mp4",
          },
        ],

        bundle: [
          {
            productId: 123,
            sku: "EG0345876534567",
            image: "https://picsum.photos/800",
          },
          {
            productId: 123,
            sku: "EG0345876534567",
            image: "https://picsum.photos/800",
          },
          {
            productId: 123,
            sku: "EG0345876534567",
            image: "https://picsum.photos/800",
          },
        ],
        quickDetails: `احصل على شعر أكثر كثافة وقوة lockinfoع عرض 3 قطع سيرم نمو الشعر الطبيعي من LANBENA، فرصتك للحصول على شعر يبدو أكثر صحة وجاذبية اطلب العرض الحين.
   هل تعاني من تساقط الشعر؟ جرب سيرم نمو الشعر الطبيعي من LANBENA واستعد للحصول على فروة رأس صحية وشعر أقوى وأكثر امتلاء, اطلب 3 قطع بسعر حصري.
   اكتشف فوائد سيرم نمو الشعر الطبيعي من LANBENA واستمتع بشعر قوي وجميل, اطلب الحين عرض 3 قطع قبل نفاذ الكمية.`,

        keywords: [
          "كلمة مفتاحية١",
          "كلمة مفتاحية٢",
          "كلمة مفتاحية٣",
          "العناية بالشعر",
          "سيرم الشعر",
          "نمو الشعر",
        ],
        howToUse:
          "ضع كمية صغيرة على الشعر النظيف والرطب. دلك بلطف في فروة الرأس واتركه. للحصول على أفضل النتائج، استخدمه يوميًا بعد غسل الشعر بالشامبو. تجنب ملامسته للعينين.",
      };
      variants.push(variant);
    });
  });

  return variants;
};

export const generateOptionsFromVariants = (
  variants: ProductDetailsVariantEntity[],
) => {
  const options: ProductDetailsOptionsEntity = {
    colors: [
      ...new Set(
        variants.map(variant => variant.color).filter(Boolean) as Color[],
      ),
    ],
    sizes: [
      ...new Set(
        variants.map(variant => variant.size).filter(Boolean) as string[],
      ),
    ],
  };

  return options;
};
